import { useAppSelector } from "./hooks";
import { normalizeI18nKey } from "../store/Slices/LanguageTextListSlice";

export function lookupTranslation(
  map: Record<string, string> | undefined,
  mapNorm: Record<string, string> | undefined,
  text: string,
): string {
  if (!text) return text;
  if (map) {
    const exact = map[text];
    if (exact != null && exact !== "") return exact;
  }
  if (mapNorm) {
    const soft = mapNorm[normalizeI18nKey(text)];
    if (soft != null && soft !== "") return soft;
  }
  return text;
}

const TextTranslate: React.FC<{ text: string }> = ({ text }) => {
  const map = useAppSelector((state) => state.LanguageTextList?.data?.map);
  const mapNorm = useAppSelector(
    (state) => state.LanguageTextList?.data?.mapNorm,
  );
  return <>{lookupTranslation(map, mapNorm, text)}</>;
};

export default TextTranslate;
